var moment = require('moment');


export const showToolTip = (c) => {
    var m = moment(c.timeRange[1]);
    return m.format('dddd, MMMM Do YYYY')
} 

